import { Component, Input } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-key-value-pair',
    template: `
    <ng-container *ngIf="multiline; else singleLine">
      <div class="flex flex-col" [attr.data-cy]="key ?? name.toLowerCase()">
        <h3>
          {{ name }}
        </h3>
        <p *ngFor="let line of multiLineValue">{{ line }}</p>
      </div>
    </ng-container>
    <ng-template #singleLine>
      <p [attr.data-cy]="key ?? name.toLowerCase()">
        <strong>{{ name }}: </strong>
        <span data-cy="value-container" *ngIf="validValue; else notSet">{{
          value
        }}</span>
        <ng-template #notSet>
          <em data-cy="not-set-message">{{ notSetMessage }}</em>
        </ng-template>
      </p>
    </ng-template>
  `,
    standalone: true,
    imports: [NgIf, NgFor]
})
export class KeyValuePairComponent {
  @Input() key: string;
  @Input() name: string;
  @Input() value: string;
  @Input() notSetMessage = 'Not assigned';
  @Input() multiline = false;

  get multiLineValue(): string[] {
    return (this.value ?? '').split('\n');
  }

  get validValue(): boolean {
    return this.value !== null && this.value !== undefined && this.value !== '';
  }
}
